import Booking from '../../api/controllers/Booking/Booking';
import { Booking as BookingType } from '../../contexts/BookingContext/BookingContext';
import { HotelConfiguration } from '../../hooks/useHotelConfig/useHotelConfig';
import { Booking as ApiBooking } from '../../types/Booking';
import { formatKioskToWaypoint, formatTomTomApiResultToWaypoint } from '../waypoint/waypoint';

export const submitBooking = (booking: BookingType, kioskInfo: HotelConfiguration) => {
  const apiBooking: ApiBooking = {
    nameOnBooking: booking.name,
    passengerCount: booking.passengers,
    phone: booking.phoneNumber,
    paymentMethod: 'card',
    carType: 'large',
    source: 'kiosk',
    waypoints: [
      { ...formatKioskToWaypoint(kioskInfo), index: 0 },
      { ...formatTomTomApiResultToWaypoint(booking.destination), index: 1 },
    ],
  };

  return Booking.create(apiBooking);
};
